"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GA_ID = exports.SETUP_LOCAL_APP = void 0;
var react_1 = __importStar(require("react"));
var react_dom_1 = __importDefault(require("react-dom"));
var Loader_1 = __importDefault(require("./template/ui/spiner/Loader"));
require("./i18app");
var react_ga4_1 = __importDefault(require("react-ga4"));
var Scroll_1 = __importDefault(require("./template/component/scroll/Scroll"));
var PurchaseView = react_1.default.lazy(function () { return Promise.resolve().then(function () { return __importStar(require('./pages/game/view/PurchaseView')); }); });
var Contact = react_1.default.lazy(function () { return Promise.resolve().then(function () { return __importStar(require('./pages/service/contact/Contact')); }); });
var Alphabet = react_1.default.lazy(function () { return Promise.resolve().then(function () { return __importStar(require('./pages/index/alphabet/Alphabet')); }); });
var OrderService = react_1.default.lazy(function () { return Promise.resolve().then(function () { return __importStar(require('./pages/service/order/OrderServiceView')); }); });
var Calculator = react_1.default.lazy(function () { return Promise.resolve().then(function () { return __importStar(require('./pages/game/components/calculator/Calculator')); }); });
;
var CheckoutOrder = react_1.default.lazy(function () { return Promise.resolve().then(function () { return __importStar(require('./pages/order/checkout/CheckoutOrder')); }); });
var SearchGame = react_1.default.lazy(function () { return Promise.resolve().then(function () { return __importStar(require('./template/component/search-game/SearchGame')); }); });
var Comments = react_1.default.lazy(function () { return Promise.resolve().then(function () { return __importStar(require('./template/component/comments/Comments')); }); });
var OrderComment = react_1.default.lazy(function () { return Promise.resolve().then(function () { return __importStar(require('./pages/order/checkout/OrderComment')); }); });
var OrderQuestion = react_1.default.lazy(function () { return Promise.resolve().then(function () { return __importStar(require('./pages/order/checkout/OrderQuestion')); }); });
var Humburger = react_1.default.lazy(function () { return Promise.resolve().then(function () { return __importStar(require('./template/component/humburger/Humburger')); }); });
var SocialViberValue = react_1.default.lazy(function () { return Promise.resolve().then(function () { return __importStar(require('./template/component/social/SocialViberValue')); }); });
var SocialDiscordValue = react_1.default.lazy(function () { return Promise.resolve().then(function () { return __importStar(require('./template/component/social/SocialDiscordValue')); }); });
var GameRating = react_1.default.lazy(function () { return Promise.resolve().then(function () { return __importStar(require('./pages/game/components/calculator/components/GameRating/GameRating')); }); });
exports.SETUP_LOCAL_APP = true;
exports.GA_ID = "GTM-55FHCMN";
react_ga4_1.default.initialize(exports.GA_ID);
window.addEventListener("scroll", function (event) {
    var _a, _b;
    var top = this.scrollY;
    if (top > 250) {
        (_a = document.getElementById("scrool-layout")) === null || _a === void 0 ? void 0 : _a.style.setProperty('display', 'block');
    }
    else {
        (_b = document.getElementById("scrool-layout")) === null || _b === void 0 ? void 0 : _b.style.setProperty('display', 'none');
    }
}, false);
var alphabetView = document.getElementById("react-alphabet");
(alphabetView) && react_dom_1.default.render(react_1.default.createElement(react_1.Suspense, { fallback: react_1.default.createElement(Loader_1.default, null) },
    react_1.default.createElement(Alphabet, null)), alphabetView);
var searchGameView = document.getElementById("react-search-header");
(searchGameView) && react_dom_1.default.render(react_1.default.createElement(react_1.Suspense, { fallback: react_1.default.createElement(Loader_1.default, null) },
    react_1.default.createElement(SearchGame, null)), searchGameView);
var searchGameMobileView = document.getElementById("react-search-header-mobile");
(searchGameMobileView) && react_dom_1.default.render(react_1.default.createElement(react_1.Suspense, { fallback: react_1.default.createElement(Loader_1.default, null) },
    react_1.default.createElement(SearchGame, null)), searchGameMobileView);
var scrollView = document.getElementById('react-scroll');
(scrollView) && react_dom_1.default.render(react_1.default.createElement(react_1.Suspense, { fallback: react_1.default.createElement(Loader_1.default, null) },
    react_1.default.createElement(Scroll_1.default, null)), scrollView);
var socialViberValue = document.getElementById('socail-viber-value');
if (socialViberValue) {
    react_dom_1.default.render(react_1.default.createElement(react_1.Suspense, { fallback: react_1.default.createElement(Loader_1.default, null) },
        react_1.default.createElement(SocialViberValue, null)), socialViberValue);
}
var orderComment = document.getElementById('react-comments-order');
if (orderComment) {
    react_dom_1.default.render(react_1.default.createElement(react_1.Suspense, { fallback: react_1.default.createElement(Loader_1.default, null) },
        react_1.default.createElement(OrderComment, null)), orderComment);
}
var orderQuestion = document.getElementById('react-question-order');
if (orderQuestion) {
    react_dom_1.default.render(react_1.default.createElement(react_1.Suspense, { fallback: react_1.default.createElement(Loader_1.default, null) },
        react_1.default.createElement(OrderQuestion, null)), orderQuestion);
}
var socialDiscorfValue2 = document.getElementById('scrool-header-discord');
if (socialDiscorfValue2) {
    react_dom_1.default.render(react_1.default.createElement(react_1.Suspense, { fallback: react_1.default.createElement(Loader_1.default, null) },
        react_1.default.createElement(SocialDiscordValue, null)), socialDiscorfValue2);
}
var socialViberfValue2 = document.getElementById('scrool-header-viber');
if (socialViberfValue2) {
    react_dom_1.default.render(react_1.default.createElement(react_1.Suspense, { fallback: react_1.default.createElement(Loader_1.default, null) },
        react_1.default.createElement(SocialViberValue, null)), socialViberfValue2);
}
var socialDiscorfValue = document.getElementById('social-discord-value');
if (socialDiscorfValue) {
    react_dom_1.default.render(react_1.default.createElement(react_1.Suspense, { fallback: react_1.default.createElement(Loader_1.default, null) },
        react_1.default.createElement(SocialDiscordValue, null)), socialDiscorfValue);
}
var hamburgerView = document.getElementById("react-humburger");
(hamburgerView) && react_dom_1.default.render(react_1.default.createElement(react_1.Suspense, { fallback: react_1.default.createElement(Loader_1.default, null) },
    react_1.default.createElement(Humburger, null)), hamburgerView);
var commentsView = document.getElementById('react-comment');
(commentsView) && react_dom_1.default.render(react_1.default.createElement(react_1.Suspense, { fallback: react_1.default.createElement(Loader_1.default, null) },
    react_1.default.createElement(Comments, { pageUrl: commentsView.getAttribute('data-page-url') })), commentsView);
var calculatorView = document.getElementById("react-calculator");
(calculatorView) && react_dom_1.default.render(react_1.default.createElement(react_1.Suspense, { fallback: react_1.default.createElement(Loader_1.default, null) },
    react_1.default.createElement(Calculator, null)), calculatorView);
var gameStars = document.getElementById("react-game-not-active-stars");
(gameStars) && react_dom_1.default.render(react_1.default.createElement(react_1.Suspense, { fallback: react_1.default.createElement(Loader_1.default, null) },
    react_1.default.createElement(GameRating, { flagOutside: true })), gameStars);
var purchaseViewView = document.getElementById("react-open-modal-purchase");
(purchaseViewView) && react_dom_1.default.render(react_1.default.createElement(react_1.Suspense, { fallback: react_1.default.createElement(Loader_1.default, null) },
    react_1.default.createElement(PurchaseView, null)), purchaseViewView);
var serviceContactFormView = document.getElementById("react-service-contact-form");
(serviceContactFormView) && react_dom_1.default.render(react_1.default.createElement(react_1.Suspense, { fallback: react_1.default.createElement(Loader_1.default, null) },
    react_1.default.createElement(Contact, null)), serviceContactFormView);
var orderServiceView = document.getElementById("react-service-form");
(orderServiceView) && react_dom_1.default.render(react_1.default.createElement("div", null,
    react_1.default.createElement(react_1.Suspense, { fallback: react_1.default.createElement(Loader_1.default, null) },
        react_1.default.createElement(OrderService, null))), orderServiceView);
var orderPaymentView = document.getElementById("react-payment-order");
(orderPaymentView) && react_dom_1.default.render(react_1.default.createElement("div", null,
    react_1.default.createElement(react_1.Suspense, { fallback: react_1.default.createElement(Loader_1.default, null) },
        react_1.default.createElement(CheckoutOrder, null))), orderPaymentView);
